module.exports = __webpack_public_path__ + "img/icon-appraisal.25f2ec9e.svg";